import { Box, Grid, Modal, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import LoaderComponent from "./LoaderComponent";

export default function ({
  menuModal,
  setMenuModal,
  minutesSupport,
  currentMenuList,
}) {
  var columnsPerRow = 6;
  if (window.innerWidth < 769) {
    columnsPerRow = 3;
  } else if (window.innerWidth < 600) {
    columnsPerRow = 2;
  }

  const [lastRowColumns, setLastRowColumns] = useState<string[]>([]);
  useEffect(() => {
    if (currentMenuList) {
      const columnsInLastRow =
        currentMenuList.length % columnsPerRow || columnsPerRow;

      const lastRow = currentMenuList.slice(-columnsInLastRow);

      setLastRowColumns(lastRow);
    }
  }, [currentMenuList, columnsPerRow]);
  return (
    <Modal
      open={menuModal}
      onClose={() => {
        setMenuModal(false);
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box
        className={"modal-wrapper menu-modal min-" + minutesSupport + "-modal"}
      >
        <Box className="modal">
          <div className="modal-heading">
            <div className="modal-heading-text">
              <img src={`/images/icon_${minutesSupport}min.png`} />
              <div>
                {/* <Typography className="min-modal-title">
                  {minutesSupport == 20 &&
                    "ちょこっと聞きたい。気軽な相談メニュー"}
                  {minutesSupport == 40 &&
                    "ネットの設定やソフトを使って何かを作るときにしっかりサポート"}
                  {minutesSupport == 80 &&
                    "購入後の初期設定から、買い換えたパソコンへのデータ移行などガッツリ設定メニュー"}
                </Typography> */}
                <Typography
                  component={"p"}
                  className="min-modal-title font-cur"
                >
                  サポートチケットで解決できるお悩みの例
                </Typography>
              </div>
            </div>
            <button className="back-btn" onClick={() => setMenuModal(false)}>
              閉じる
            </button>
          </div>
          {currentMenuList && minutesSupport && currentMenuList ? (
            <Box className="modal-body">
              <Grid container className="menu-ticket-wrapper">
                {currentMenuList.length ? (
                  currentMenuList.map((lst, idx) => {
                    var id = idx + parseInt(minutesSupport);
                    return (
                      <Grid
                        key={idx}
                        item
                        lg={2}
                        md={4}
                        sm={4}
                        xs={6}
                        className={`menu-modal-ticket ${
                          lastRowColumns.includes(lst) ? "last-row" : ""
                        }`}
                      >
                        <Box>
                          <Typography>{lst.menuTitle} </Typography>
                          <Box>
                            <img src={lst.imageUrl} alt="" />
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })
                ) : (
                  <Typography>Empty List</Typography>
                )}
              </Grid>
            </Box>
          ) : (
            <LoaderComponent />
          )}
        </Box>
      </Box>
    </Modal>
  );
}
